var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBonusTotal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6DD663",
    fillRule: "evenodd",
    d: "M25 48C12.317 48 2 37.683 2 25S12.317 2 25 2a.959.959 0 010 1.917C13.375 3.917 3.917 13.375 3.917 25c0 11.625 9.458 21.083 21.083 21.083 11.625 0 21.083-9.458 21.083-21.083A.959.959 0 0148 25c0 12.683-10.317 23-23 23z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6DD663",
    strokeWidth: 2.76,
    d: "M25 48C12.317 48 2 37.683 2 25S12.317 2 25 2a.959.959 0 010 1.917C13.375 3.917 3.917 13.375 3.917 25c0 11.625 9.458 21.083 21.083 21.083 11.625 0 21.083-9.458 21.083-21.083A.959.959 0 0148 25c0 12.683-10.317 23-23 23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8838CD",
    fillRule: "evenodd",
    d: "M45.873 11.296L24.789 32.379a.973.973 0 01-.69.288h-.06a.893.893 0 01-.668-.288l-9.583-9.583a.926.926 0 010-1.342.925.925 0 011.34 0l8.95 8.951L44.51 9.955a.95.95 0 011.363 0 .962.962 0 010 1.34z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8838CD",
    strokeWidth: 2.76,
    d: "M45.873 11.296L24.789 32.379a.973.973 0 01-.69.288h-.06a.893.893 0 01-.668-.288l-9.583-9.583a.926.926 0 010-1.342.925.925 0 011.34 0l8.95 8.951L44.51 9.955a.95.95 0 011.363 0 .962.962 0 010 1.34"
  })));
}
SvgBonusTotal.displayName = 'BonusTotal';
export default SvgBonusTotal;